module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-products-family.6c039b4a.png";